// @flow
import * as React from 'react';
import { EmptyCard } from 'components';
import styles from './EmptyQueueMessage.scss';

const RetryButton = ({ label, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={styles.emptyQueueMessageRetryButton}
  >
    {label || 'Retry'}
  </button>
);

type EmptyQueueMessageProps = {
  onClick: () => void,
  label: string,
  title: string,
};

const EmptyQueueMessage = (props: EmptyQueueMessageProps) => (
  <EmptyCard>
    <EmptyCard.Title>{props.title}</EmptyCard.Title>
    <EmptyCard.Message>
      <RetryButton onClick={props.onClick} label={props.label} />
    </EmptyCard.Message>
  </EmptyCard>
);

export default EmptyQueueMessage;



// WEBPACK FOOTER //
// ./src/pages/__components__/EmptyQueueMessage.js